export const CreditReviewTabs = {
	AllMerchants: {
		name: "all-merchants",
		displayName: "All Merchants",
		formName: "AllMerchants",
	},
	Historical: {
		name: "historical",
		displayName: "Historical",
		formName: "Historical",
	},
	InReview: {
		name: "in-review",
		displayName: "In Review",
		formName: "InReview",
	},
};

export const getCreditReviewBreadcrumbsPageTitle = tab => {
	if (tab === CreditReviewTabs.AllMerchants.name)
		return CreditReviewTabs.AllMerchants.displayName;
	else if (tab === CreditReviewTabs.Historical.name)
		return CreditReviewTabs.Historical.displayName;
	else return CreditReviewTabs.InReview.displayName;
};
